import envConfig from '../../static/config';
import config from '../config';
import ApiUtils from './ApiUtils';
import SpendingsActionCreator from '../actions/SpendingsActionCreator';
import UserManagementStore from '../stores/UserManagementStore';

const _getBudgetDataEndPoint = '/ibapi/v2/banks/{bank-id}/budget';
const _getSpendingDataEndpoint =
  '/ibapi/v2/banks/{bank-id}/accounts/default/transactions/aggregations/breakDownOfSpend';
const _getTagBudgetDataEndPoint = '/ibapi/v2/banks/{bank-id}/tags/active';
const _budgetPreferencesEndPoint = '/ibapi/v2/user/budget/preferences';
const _getTransactionData =
  '/ibapi/v2/banks/{bank-id}/accounts/default/transactions/searches/matchAllWithFilter';
const _getPotsDataEndpoint =
  '/ibapi/v2/banks/{bank-id}/accounts/default/{account-id}/pots';

const _getAccountListEndpoint = '/ibapi/v2/banks/{bank-id}/accounts/default';

const SpendingsUtils = {
  /**
   * API call for getAccoountList.
   * Retrieves the list of accounts for a customer.
   */
  getAccountsList() {
    let url = envConfig.apiBaseUrlPAAS + _getAccountListEndpoint;
    if (envConfig.stubConfig) {
      url = envConfig.stubConfig.timelineStub.AccountListConnection;
    }
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.spendingDataService,
        method: 'GET',
        url,
        addAuthToken: true,
      },
      (body) => {
        SpendingsActionCreator.handleAccountsListSuccess(body);
      },
      (error, status) => {
        SpendingsActionCreator.handleAccountsListError(error, status);
      }
    );
  },

  /**
   * API call for get Spending Data.
   * Retrieves the list of Spending for a customer.
   */
  getPotsDataSpendings(accid) {
    let url = envConfig.apiBaseUrlPAAS + _getPotsDataEndpoint;
    url = url.replace('{account-id}', accid);
    if (envConfig.stubConfig) {
      const key = `GetPotsConnection-${accid}`;
      url = envConfig.stubConfig.savingspotsStub[key];
    }
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.getPots,
        method: 'GET',
        url,
        addAuthToken: true,
      },
      (body) => {
        SpendingsActionCreator.handlePotDataSpendingsSuccess(body);
      },
      () => {
        SpendingsActionCreator.handlePotDataSpendingsError();
      }
    );
  },
  /**
   * API call for getBudgetConnection.
   * Retrieves the list of Budgets for a customer.
   */
  getSpendListConnectionData(data) {
    const requestData = data;
    let url = envConfig.apiBaseUrlPAAS + _getSpendingDataEndpoint;
    if (envConfig.stubConfig) {
      url = envConfig.stubConfig.spendingStub.SpendListConnection;
    }
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.spendingDataService,
        method: 'POST',
        url,
        addAuthToken: true,
        requestData,
      },
      (body) => {
        SpendingsActionCreator.handleGetSpendListConnectionSuccess(body);
      },
      () => {
        SpendingsActionCreator.handleGetSpendListConnectionError();
      }
    );
  },

  /**
   * API call for get Spend List Connection.
   * Retrieves the list of Budgets for a customer.
   */
  getTagListConnectionData() {
    let url = envConfig.apiBaseUrlPAAS + _getTagBudgetDataEndPoint;
    if (envConfig.stubConfig) {
      url = envConfig.stubConfig.spendingStub.TagListConnection;
    }
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.tagListService,
        method: 'GET',
        url,
        addAuthToken: true,
      },
      (body) => {
        SpendingsActionCreator.handleGetTagListConnectionSuccess(body);
      },
      (error) => {
        SpendingsActionCreator.handleGetTagListConnectionError(error);
      }
    );
  },

  /**
   * API call for getBudgetConnection.
   * Retrieves the list of Budgets for a customer.
   */
  getBudgetConnectionData() {
    let url = envConfig.apiBaseUrlPAAS + _getBudgetDataEndPoint;
    if (envConfig.stubConfig) {
      url = envConfig.stubConfig.spendingStub.GetBudgetConnection;
    }
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.spendingDataService,
        method: 'GET',
        url,
        addAuthToken: true,
      },
      (body) => {
        SpendingsActionCreator.handleGetBudgetConnectionSuccess(body);
      },
      (error) => {
        SpendingsActionCreator.handleGetBudgetConnectionError(error);
      }
    );
  },

  /**
   * API call for getBudgetConnection.
   * Retrieves the list of Budgets for a customer.
   */

  updatePreferencesAndBudgetConnectionData(data) {
    const requestData = data.earnings;
    let url = envConfig.apiBaseUrlPAAS + _budgetPreferencesEndPoint;
    if (envConfig.stubConfig) {
      url = envConfig.stubConfig.spendingStub.GetBudgetPreferencesConnection;
    }
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.spendingDataService,
        method: 'PUT',
        url,
        addAuthToken: true,
        requestData,
      },
      () => {
        SpendingsActionCreator.updateBudgetPreferencesConnectionSuccess(
          requestData
        );
        this.updateBudgetConnectionData(data.budgetPacket);
      },
      (error) => {
        SpendingsActionCreator.updateBudgetPreferencesConnectionError(error);
      }
    );
  },

  updateBudgetConnectionData(data) {
    let url = envConfig.apiBaseUrlPAAS + _getBudgetDataEndPoint;
    const requestData = data;
    if (envConfig.stubConfig) {
      url = envConfig.stubConfig.spendingStub.GetBudgetConnection;
    }
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.spendingDataService,
        method: 'PUT',
        url,
        addAuthToken: true,
        requestData,
      },
      (body) => {
        SpendingsActionCreator.handleUpdateBudgetConnectionSuccess(body);
      },
      (error) => {
        SpendingsActionCreator.handleUpdateBudgetConnectionError(error);
      }
    );
  },

  /**
   * API call for getBudgetConnection.
   * Retrieves the list of Budgets for a customer.
   */
  getBudgetPreferencesConnectionData() {
    let url = envConfig.apiBaseUrlPAAS + _budgetPreferencesEndPoint;
    if (envConfig.stubConfig) {
      url = envConfig.stubConfig.spendingStub.GetBudgetPreferencesConnection;
    }
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.spendingDataService,
        method: 'GET',
        url,
        addAuthToken: true,
      },
      (body) => {
        SpendingsActionCreator.handleGetBudgetPreferencesConnectionSuccess(
          body
        );
      },
      (error) => {
        SpendingsActionCreator.handleGetBudgetPreferencesConnectionError(error);
      }
    );
  },

  /**
   * API call for getTagListConnection..
   * Retrieves the list of Budgets for a customer.
   */
  transactionData(data, scenario = 'getTransaction') {
    const requestData = data;
    let url = envConfig.apiBaseUrlPAAS + _getTransactionData;
    if (envConfig.stubConfig) {
      url = envConfig.stubConfig.spendingStub.TransactionListConnection;
    }
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.spendingDataService,
        method: 'POST',
        url,
        addAuthToken: true,
        requestData,
      },
      (body) => {
        if (scenario === 'getTransaction') {
          SpendingsActionCreator.handleTransactionDetailsSuccess(body);
        } else {
          SpendingsActionCreator.handleTransactionDetailsOnSortSuccess(body);
        }
      },
      (error) => {
        SpendingsActionCreator.handleTransactionDetailsError(error);
      }
    );
  },
  /**
   *
   * Number Validation for Earnings Screen
   *
   */
  numberValidation(val) {
    const etarget = val.replace(/[^\d.]*/g, '');
    const len = etarget.length;
    const index = etarget.indexOf('.');
    const dots = etarget.split('.').length;
    const beforeDecimalLen = etarget.split('.')[0].length;
    let isValid = true;
    if (beforeDecimalLen > 6) {
      isValid = false;
    }
    if (dots > 2 || Number(etarget) > 999999 || etarget === '999999.') {
      isValid = false;
    }
    if (index >= 0) {
      const CharAfterdot = len + 1 - index;
      if (CharAfterdot > 4) {
        isValid = false;
      }
    }
    return isValid;
  },
  /**
   *
   * Number Validation for create edit budget page
   *
   */
  numberValidationForCreateEditBudget(val) {
    const etarget = val.replace(/[^\d.]*/g, '');
    const len = etarget.length;
    const index = etarget.indexOf('.');
    const dots = etarget.split('.').length;
    const beforeDecimalLen = etarget.split('.')[0].length;
    let isValid = true;
    if (beforeDecimalLen > 6) {
      isValid = false;
    }
    if (
      dots > 2 ||
      Number(etarget) > 999999 ||
      etarget === '999999.' ||
      Number(etarget) > 10000
    ) {
      isValid = false;
    }
    if (index >= 0) {
      const CharAfterdot = len + 1 - index;
      if (CharAfterdot > 4) {
        return (isValid = false);
      }
    }
    if (beforeDecimalLen === 6) {
      if (Number(etarget) >= 10000) {
        isValid = false;
      } else {
        isValid = true;
      }
    }
    return isValid;
  },
};

export const isSpendingsEnabled = () =>
  envConfig.isSpendingsEnabled && !UserManagementStore.isSMEUser();

export default SpendingsUtils;
